export const LOAD_MORE_CTA_COPY = "Laporan Lain";
